var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragLine = function SvgDragLine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14787_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8516 0.506348L43.7656 43.7827L47.9785 48.3784V66.3784L44.5322 69.8257L36.4893 72.5063L28.4473 69.8257L25 66.3784V48.3784L29.2129 43.7827L31.1279 0.506348H41.8516Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.498 32.5417L39.4375 32.4277L39.4965 32.4591L39.498 32.5417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.537 31.5693L41.245 25.1835L40.1975 25.2314L39.3314 14.4229L40.5661 14.3217L40.3095 11.1899L39.0804 11.2907L38.836 8.24182H39.9325V5.09957H38.7543V2.86035H34.3239V5.09957H33.3096V8.24182H34.2421L33.9988 11.2773L32.9326 11.1899L32.676 14.3217L33.7478 14.4096L32.8808 25.2312L31.8408 25.1836L31.5488 31.5694L32.5198 31.6138L32.1437 51.7373H33.1987L33.312 45.6751L33.6486 45.4977H39.7631L39.8797 51.7373H40.9346L40.5585 31.6142L41.537 31.5693ZM38.4225 16.2447L38.3725 16.1511L34.4973 18.2191L34.9008 13.1842L38.3229 15.0023L38.4225 16.2447ZM34.3014 20.6652L38.9129 23.0971L38.964 23.0004L39.0181 23.6766L38.9969 23.6363L33.846 26.3507L34.3014 20.6652ZM39.5208 32.5419L39.4602 32.4279L39.5192 32.4592L39.5208 32.5419ZM33.6749 28.4841L33.7165 27.9655H39.3617L39.4576 29.1624L39.5027 31.5748L33.6749 28.4841ZM33.9083 27.192L39.0813 24.466L39.2997 27.192H33.9083ZM39.4324 32.4132L33.5009 35.5642L33.6174 29.3291L39.4324 32.4132ZM33.3297 44.7243L33.359 43.1611H36.4232L33.4567 44.7243H33.3297ZM33.3734 42.3877L33.4482 38.381L39.4285 41.5774L37.8908 42.3877H33.3734ZM39.7033 42.307L39.7049 42.3877H39.5503L39.7033 42.307ZM33.4645 37.5126L33.4845 36.449L39.5338 33.2352L39.6759 40.8325L33.4645 37.5126ZM38.9011 22.2164L34.3814 19.8329L34.3657 19.8625L34.4241 19.1349L38.4807 16.9701L38.9011 22.2164ZM38.0507 11.6036L38.2498 14.0874L34.9682 12.3442L35.0275 11.6035L38.0507 11.6036ZM35.1162 44.7243L38.0826 43.1611H39.7193L39.7486 44.7243H35.1162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.502 48.1689H28.2664V50.9439H27.5726L27.3535 52.514V65.1477L29.6904 67.1194L32.4654 52.1489L32.502 48.1689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2441 48.1689H44.4797V50.9439H45.1735L45.3926 52.514V65.1477L43.0557 67.1194L40.2807 52.1489L40.2441 48.1689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1476 51.9302V48.1245H43.2456V67.2995L36.4636 69.3975L29.584 67.2995V48.1245H31.682V51.9302H41.1476Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.16022
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6641 52.1455H43.2068",
    stroke: "black",
    strokeWidth: 0.580108
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2374 55.0376H30.8203V57.5514H33.2374V55.0376Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2374 59.4849H30.8203V61.9987H33.2374V59.4849Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2374 63.7388H30.8203V66.2526H33.2374V63.7388Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6476 55.0376H39.2305V57.5514H41.6476V55.0376Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6476 59.4849H39.2305V61.9987H41.6476V59.4849Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6476 63.7388H39.2305V66.2526H41.6476V63.7388Z",
    fill: "#C68106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1355 46.5811H33.8984V54.5536H39.1355V46.5811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8311 54.167H34.9609V66.6393H35.8311V54.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0557 54.167H37.1855V66.6393H38.0557V54.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5566 10.6914V52.4592",
    stroke: "black",
    strokeWidth: 0.290054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7812 10.6914V52.4592",
    stroke: "black",
    strokeWidth: 0.290054
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2676 10.6914V52.4592",
    stroke: "black",
    strokeWidth: 0.290054
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14787_461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "drag-line.004d14326dcff17940ca167715195e2e.svg";